export default __webpack_public_path__ + "static/media/1994.da8cc262.png";